module.exports = __webpack_public_path__ + "media/images/flags/16/Tajikistan-983892f80977470e20480fea11ed82ad.png";